import { forwardRef } from 'react';

/**
 * Reusable Form Textarea — compatible with react-hook-form `register()`
 */
const FormTextarea = forwardRef(
  (
    {
      label,
      field,
      placeholder,
      error,
      required = false,
      readOnly = false,
      disabled = false,
      icon,
      rows = 4,
      className = '',
      labelClassName = '',
      inputClassName = '',
      hideError = false,
      helperText,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={`space-y-1.5 ${className}`}>
        {/* Label */}
        {label && (
          <label
            htmlFor={field}
            className={`flex items-center gap-1.5 text-[13px] font-medium text-slate-500 ${labelClassName}`}
          >
            {icon && <span className="text-slate-400 flex-shrink-0">{icon}</span>}
            {label}
            {required && <span className="text-red-500 text-xs">*</span>}
          </label>
        )}

        {/* Textarea */}
        <textarea
          ref={ref}
          id={field}
          name={field}
          rows={rows}
          readOnly={readOnly}
          disabled={disabled}
          placeholder={placeholder}
          className={[
            'w-full border rounded-md px-3 py-2.5 text-[13px]',
            'text-slate-800 placeholder-slate-400 resize-none',
            'focus:outline-none focus:ring-1 transition-all bg-white leading-relaxed',
            error
              ? 'border-red-300 focus:border-red-500 focus:ring-red-200'
              : 'border-slate-200 focus:border-brand-blue focus:ring-brand-blue/30',
            readOnly && 'bg-slate-50 cursor-not-allowed text-slate-500',
            disabled && 'bg-slate-100 cursor-not-allowed opacity-60',
          ]
            .filter(Boolean)
            .join(' ')}
          {...props}
        />

        {/* Error / Helper */}
        {error && (
          <p className="text-[12px] text-red-500 font-medium">{error}</p>
        )}
        {!error && helperText && (
          <p className="text-[11px] text-slate-400 font-normal">{helperText}</p>
        )}
      </div>
    );
  },
);

FormTextarea.displayName = 'FormTextarea';
export default FormTextarea;




